module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//fire_1.png?v=d9e26727";